import { Box, palette, styled } from '@mui/system'
import 'react-date-range/dist/styles.css'; // main style file
import 'react-date-range/dist/theme/default.css'; // theme css file
import {
  Button,
  Card,
  CardContent,
  CardHeader, Chip,
  Dialog, DialogContent,
  Divider, FormControl,
  Grid, InputLabel, Menu, MenuItem, OutlinedInput,
  Paper, Select,
  Skeleton, Table, TableBody, TableCell,
  TableContainer, TableHead, TableRow, Tooltip,
  Typography
} from '@mui/material'
import moment from 'moment'
import { getCondoId, getFilterDate, setFilterDate } from '../../../services/Main/AuthStorage'
import { useContext, useEffect, useState } from 'react'
import Context from '../../../contexts/Context'
import {
  ArticleOutlined,
  CurrencyExchange,
  DescriptionOutlined,
  PaidOutlined,
  PaymentsOutlined, PendingActionsOutlined,
  ReceiptOutlined, RequestQuoteOutlined
} from '@mui/icons-material'
import { api } from '../../../services/Main/Api'
import { useSearchParams } from 'react-router-dom'
import Masks from '../../../components/Shared/Masks'
import { BarChart } from '@mui/x-charts/BarChart';
import { LineChart } from '@mui/x-charts/LineChart';

import * as React from 'react'
import Brasil from '../../../components/Shared/Brasil'

import NoResultsAnimation from '../../../components/Shared/animations/NoResultsAnimation'

import { subDays, startOfYear, endOfYear, subMonths, startOfMonth, endOfMonth } from 'date-fns'
import { DateRangePicker } from 'react-date-range';
import { CalendarIcon } from '@mui/x-date-pickers'
import RankingCondo from "./RankingCondo";
import TransactionsChart from "./Chart/TransactionsChart";
import TransactionsTotalLast3YearsChart from "./Chart/TransactionsYearsChart";





const AdminDashboard = () => {

  const storageDate = getFilterDate()

  const { condoIdLogin } = useContext(Context)
  const [dataRange, setDateRange] = useState([
    {
      startDate: startOfMonth(subMonths(new Date(), 12)),
      endDate: new Date(),
      key: 'selection'
    }
  ])


  const [startDate, setStartDate] = useState(null)
  const [endDate, setEndDate] = useState(null)
  const [condo, setCondo] = useState(null)

  const [result, setResult] = useState({})
  const [transactionYear, setTransactionYear] = useState({})
  const [transactionMonth, setTransactionMonth] = useState({})
  const [loadingResult, setLoadingResult] = useState(false)
  const [resultSixMonthsValue, setResultSixMonthsValue] = useState([])
  const [resultSixMonths, setResultSixMonths] = useState([])
  const [transactionQuantity, setTransactionQuantity] = useState([])
  const [transactionResult, setTransactionResult] = useState([])
  const [transactionQuantityValue, setTransactionQuantityValue] = useState([])
  const [billingCompany, setBillingCompany] = useState({
    xAxis: [],
    ySeries: []
  })
  const [transactionTotalMonth, setTransactionTotalMonth] = useState({
    xAxis: [],
    ySeries: []
  })

  const [transactionBlocoB3TotalMonth, setTransactionBlocoB3TotalMonth] = useState({
    xAxis: [],
    ySeries: []
  })
  const [invoiceCount, setInvoiceCount] = useState({
    valueMax: 0,
    value: 0,
    percentage: 0
  })

  const [transferCount, setTransferCount] = useState({
    valueMax: 0,
    value: 0,
    percentage: 0
  })
  const [searchParams, setSearchParams] = useSearchParams();


// Funções de intervalos separadas
   const getCurrentMonthRange = () => ({
    startDate: startOfMonth(new Date()),  // Início do mês atual
    endDate: endOfMonth(new Date()),      // Fim do mês atual
  });

   const getLastMonthRange = () => ({
    startDate: startOfMonth(subMonths(new Date(), 1)),  // Início do último mês
    endDate: endOfMonth(subMonths(new Date(), 1)),      // Fim do último mês
  });

   const getLast30DaysRange = () => ({
    startDate: subDays(new Date(), 30),  // Últimos 30 dias
    endDate: new Date(),
  });

    const getLast3MonthsRange = () => {
        const now = new Date();
        return {
            // volta 3 meses e fixa no dia 1
            startDate: startOfMonth(subMonths(now, 3)),
            endDate: now,
        };
    };

    const getLast6MonthsRange = () => {
        const now = new Date();
        return {
            startDate: startOfMonth(subMonths(now, 6)),
            endDate: now,
        };
    };

    const getLast12MonthsRange = () => {
        const now = new Date();
        return {
            startDate: startOfMonth(subMonths(now, 12)),
            endDate: now,
        };
    };


    const getCurrentYearRange = () => ({
    startDate: startOfYear(new Date()),  // Início do ano
    endDate: endOfYear(new Date()),      // Fim do ano
  });

  const customStaticRanges = [
    {
      label: 'Mês atual',
      range: getCurrentMonthRange, // Referência à função
      isSelected(range) {
        return range.startDate === startOfMonth(new Date()) && range.endDate === endOfMonth(new Date());
      },
    },
    {
      label: 'Último mês',
      range: getLastMonthRange, // Referência à função
      isSelected(range) {
        const lastMonthStart = startOfMonth(subMonths(new Date(), 1));
        const lastMonthEnd = endOfMonth(subMonths(new Date(), 1));
        return range.startDate === lastMonthStart && range.endDate === lastMonthEnd;
      },
    },
    {
      label: 'Últimos 30 dias',
      range: getLast30DaysRange, // Referência à função
      isSelected(range) {
        const now = new Date();
        const lastThirtyDays = subDays(now, 30);
        return range.startDate === lastThirtyDays && range.endDate === now;
      },
    },
    {
      label: 'Últimos 3 meses',
      range: getLast3MonthsRange, // Referência à função
      isSelected(range) {
        const now = new Date();
        const lastThreeMonths = subMonths(now, 3);
        return range.startDate === lastThreeMonths && range.endDate === now;
      },
    },
    {
      label: 'Últimos 6 meses',
      range: getLast6MonthsRange, // Referência à função
      isSelected(range) {
        const now = new Date();
        const lastSixMonths = subMonths(now, 6);
        return range.startDate === lastSixMonths && range.endDate === now;
      },
    },
    {
      label: 'Últimos 12 meses',
      range: getLast12MonthsRange, // Referência à função
      isSelected(range) {
        const now = new Date();
        const lastYear = subMonths(now, 12);
        return range.startDate === lastYear && range.endDate === now;
      },
    },
    {
      label: 'Neste ano',
      range: getCurrentYearRange, // Referência à função
      isSelected(range) {
        return range.startDate === startOfYear(new Date()) && range.endDate === endOfYear(new Date());
      },
    },
  ];





  function getSixMonthsRentData(){

    let filter = {
      start_date: startDate,
      end_date: endDate,
      condo_id: condo,
    }

    api.get(`analytics/admin-rent-contract/`, {params: filter})
      .then(response => {
        const data = response.data

        setResultSixMonths(data.months)
        setResultSixMonthsValue(data.values)
        //setLoading(false)
      }).catch(error => {
      console.log(error)
      //setLoading(false)
    })
  }

  function getTransactionQuantity(){

    let filter = {
      start_date: startDate,
      end_date: endDate,
      condo_id: condo,
    }

    api.get(`analytics/transaction-month-quantity/`, {params: filter})
      .then(response => {
        const data = response.data

        setTransactionQuantity(data.months)
        setTransactionQuantityValue(data.values)
        //setLoading(false)
      }).catch(error => {
      console.log(error)
      //setLoading(false)
    })
  }



  function getTransactionMonth(){

    let filter = {
      start_date: startDate,
      end_date: endDate,
      condo_id: condo,
    }

    api.get(`analytics/transaction-month/`, {params: filter})
      .then(response => {
        const data = response.data

        setTransactionMonth(data)

        //setLoading(false)
      }).catch(error => {
      console.log(error)
      //setLoading(false)
    })
  }

  function getDaysDifference(startDate, endDate) {
    const oneDay = 24 * 60 * 60 * 1000; // Milissegundos em um dia
    const start = new Date(startDate);
    const end = new Date(endDate);

    // Calcula a diferença em milissegundos e converte para dias
    const diffDays = Math.round(Math.abs((end - start) / oneDay));
    return diffDays;
  }

  function getTransactionMonthTotal(){

    let filter = {
      start_date: startDate,
      end_date: endDate,
      condo_id: condo,
    }
    if (startDate){
      api.get(`analytics/transaction-month-value/`, {params: filter})
        .then(response => {
          const data = response.data
          setTransactionTotalMonth({
            xAxis: data.months,
            ySeries: data.values,
          })

          //setLoading(false)
        }).catch(error => {
        console.log(error)
        //setLoading(false)
      })
    }
  }

  function getBlocoB3TransactionMonthTotal(){

    let filter = {
      start_date: startDate,
      end_date: endDate,
      condo_id: condo,
    }
    if (startDate){
      api.get(`analytics/admin-blocob3-fees/`, {params: filter})
          .then(response => {
            const results = response.data
            const data = results?.data

            const organizedData = data.reduce((acc, curr) => {
              const date = Object.keys(curr)[0];
              if (!acc[date]) {
                acc[date] = {};
              }
              // Verifica se o objeto tem fee ou plan e adiciona ao acumulador
              acc[date].total = acc[date].total || 0;
              if ('fee' in curr[date]) {
                acc[date].fee = curr[date].fee;
                acc[date].total += curr[date].fee;
              }
              if ('plan' in curr[date]) {
                acc[date].plan = curr[date].plan;
                acc[date].total += curr[date].plan;
              }
              acc[date].date = curr[date].date;

              return acc;
            }, {});

            // Agora vamos criar os três arrays
            const dates = Object.values(organizedData).map(item => {
              // Formata a data para DD/MM/YYYY
              return new Date(item.date).toLocaleDateString('pt-BR');
            });

            const fees = Object.values(organizedData).map(item => item.fee || 0);

            const plans = Object.values(organizedData).map(item => item.plan || 0);

            const totals = Object.values(organizedData).map(item => item.total || 0);

            const show = getDaysDifference(startDate, endDate) > 30 ? "month" : "day"
            setTransactionBlocoB3TotalMonth({
              xAxis: dates,
              ySeries: fees,
              insight: results?.insight,
              ySeriesPlan: plans,
              yTotal: totals,
              show: show
            })
          }).catch(error => {
        console.log(error)
        //setLoading(false)
      })
    }
  }

  useEffect(()=>{
      getSixMonthsRentData()
      getTransactionQuantity()
      getTransactionMonthTotal()
      getTransactionMonth()
      getBlocoB3TransactionMonthTotal()

  }, [startDate, endDate, condo])



  useEffect(()=>{


    setStartDate(moment(dataRange[0].startDate).format("YYYY-MM-DD"))
    setEndDate(moment(dataRange[0].endDate).format("YYYY-MM-DD"))


  }, [dataRange])

  useEffect(()=>{
    let params = { ...searchParams, "startDate": moment(dataRange[0].startDate).format("YYYY-MM-DD"), "endDate": moment(dataRange[0].endDate).format("YYYY-MM-DD"), }
    if (searchParams.get('condo_id') > 0){
      setCondo(searchParams.get('condo_id'))
      params.condo_id = searchParams.get('condo_id')
    }
    setSearchParams(params)
  }, [startDate, endDate, condo])


  const [listCondos, setListCondos] = useState([]);

  useEffect(() => {
    const fetchCondos = async () => {

        api.get(`condo-select/`)
            .then(response => {
              const data = response.data

              setListCondos(data);

              //setLoading(false)
            }).catch(error => {
          console.log(error)
          //setLoading(false)
        })

    };

    fetchCondos();
  }, []);

  const Item = styled(Paper)(({ theme }) => ({
    backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#fff',
    ...theme.typography.body2,
    padding: theme.spacing(2),
    textAlign: 'left',
    color: theme.palette.text.secondary,
  }));
  const [open, setOpen] = React.useState(false);
  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const [anchorEl, setAnchorEl] = React.useState(null);
  const openMenu = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleCloseMenu = () => {
    setAnchorEl(null);
  };
  const total = Number(transactionBlocoB3TotalMonth?.insight?.total) || 0;
  const cost = Number(transactionBlocoB3TotalMonth?.insight?.cost) || 0;
  const profit = total - cost;
  const profitPercent = total > 0 ? ((profit / total) * 100) : 0;
  return (
    <>


      <Grid container spacing={2} justifyContent={"space-between"}>
        <Grid item xs={12} md={12} lg={12}>
          <Grid container spacing={2} justifyContent={"space-between"}>
              <Grid item  xs={12} md={6} lg={8}>
                  <TransactionsChart />
              </Grid>
              <Grid item xs={12} md={6} lg={4}>
                  <TransactionsTotalLast3YearsChart />
              </Grid>
              <Grid item xs={12} >
                  <Divider sx={{ marginY: "2rem"}} >2025</Divider>
              </Grid>
              <Grid item xs={12} md={4} lg={4}>
              <Item >
                <Box sx={{display: "flex", justifyContent: "space-between"}}>
                  <CurrencyExchange sx={{ color:'primary.main',}} />
                  <Box>{transactionMonth?.transaction?.quantity} transações</Box>
                </Box>
                <Box>
                  <Typography variant={'overline'} sx={{color:'#212b36',  marginBottom: "1rem" }}>Total de transações</Typography>
                </Box>
                <Box sx={{display: "flex", alignItems: "center", justifyContent: "start", }}>
                  { loadingResult ?
                    <Skeleton variant="rectangular" width={200} height={50} />
                    :
                    <Typography sx={{color:'#212b36',  fontWeight: 'bold', flexGrow:1, fontSize: "1.8rem" }} >
                      {transactionMonth?.transaction?.total && Masks.money(transactionMonth?.transaction?.total.toString())}
                    </Typography>
                  }
                </Box>
              </Item>
            </Grid>
            <Grid item xs={12} md={4} lg={4}>
              <Item >
                <Box sx={{display: "flex", justifyContent: "space-between"}}>
                  <CurrencyExchange sx={{ color:'primary.main',}} />
                  <Box>{transactionMonth?.transaction_in?.quantity} transações</Box>
                </Box>
                <Box>
                  <Typography variant={'overline'} sx={{color:'#212b36',  marginBottom: "1rem" }}>Total de entrada</Typography>
                </Box>
                <Box sx={{display: "flex", alignItems: "center", justifyContent: "start", }}>
                  { loadingResult ?
                    <Skeleton variant="rectangular" width={200} height={50} />
                    :
                    <Typography sx={{color:'#212b36',  fontWeight: 'bold', flexGrow:1, fontSize: "1.8rem" }} >
                      {transactionMonth?.transaction_in?.total && Masks.money(transactionMonth?.transaction_in?.total.toString())}
                    </Typography>
                  }
                </Box>
              </Item>
            </Grid>
            <Grid item xs={12} md={4} lg={4}>
              <Item >
                <Box sx={{display: "flex", justifyContent: "space-between"}}>
                  <CurrencyExchange sx={{ color:'primary.main',}} />
                  <Box>{transactionMonth?.transaction_out?.quantity} transações</Box>
                </Box>
                <Box>
                  <Typography variant={'overline'} sx={{color:'#212b36',  marginBottom: "1rem" }}>Total de Saída</Typography>
                </Box>
                <Box sx={{display: "flex", alignItems: "center", justifyContent: "start", }}>
                  { loadingResult ?
                    <Skeleton variant="rectangular" width={200} height={50} />
                    :
                    <Typography sx={{color:'#212b36',  fontWeight: 'bold', flexGrow:1, fontSize: "1.8rem" }} >
                      {transactionMonth?.transaction_out?.total && Masks.money(transactionMonth?.transaction_out?.total.toString())}
                    </Typography>
                  }
                </Box>
              </Item>
            </Grid>
            <Grid item xs={12} md={4} lg={2}>
              <Item >
                <Box sx={{display: "flex", justifyContent: "space-between"}}>
                  <CurrencyExchange sx={{ color:'primary.main',}} />
                  <Box>{transactionMonth?.transaction_boleto_in?.quantity} transações</Box>
                </Box>
                <Box>
                  <Typography variant={'overline'} sx={{color:'#212b36',  marginBottom: "1rem" }}>Boleto(Entrada)</Typography>
                </Box>
                <Box sx={{display: "flex", alignItems: "center", justifyContent: "start", }}>
                  { loadingResult ?
                    <Skeleton variant="rectangular" width={200} height={50} />
                    :
                    <Typography sx={{color:'#212b36',  fontWeight: 'bold', flexGrow:1, fontSize: "1.8rem" }} >
                      {transactionMonth?.transaction_boleto_in?.total && Masks.money(transactionMonth?.transaction_boleto_in?.total.toString())}
                    </Typography>
                  }
                </Box>
              </Item>
            </Grid>
            <Grid item xs={12} md={4} lg={2}>
              <Item >
                <Box sx={{display: "flex", justifyContent: "space-between"}}>
                  <CurrencyExchange sx={{ color:'primary.main',}} />
                  <Box>{transactionMonth?.transaction_boleto_out?.quantity} transações</Box>
                </Box>
                <Box>
                  <Typography variant={'overline'} sx={{color:'#212b36',  marginBottom: "1rem" }}>Boleto(Saída)</Typography>
                </Box>
                <Box sx={{display: "flex", alignItems: "center", justifyContent: "start", }}>
                  { loadingResult ?
                    <Skeleton variant="rectangular" width={200} height={50} />
                    :
                    <Typography sx={{color:'#212b36',  fontWeight: 'bold', flexGrow:1, fontSize: "1.8rem" }} >
                      {transactionMonth?.transaction_boleto_out?.total && Masks.money(transactionMonth?.transaction_boleto_out?.total.toString())}
                    </Typography>
                  }
                </Box>
              </Item>
            </Grid>
            <Grid item xs={12} md={4} lg={2}>
              <Item >
                <Box sx={{display: "flex", justifyContent: "space-between"}}>
                  <CurrencyExchange sx={{ color:'primary.main',}} />
                  <Box>{transactionMonth?.transaction_pix_in?.quantity} transações</Box>
                </Box>
                <Box>
                  <Typography variant={'overline'} sx={{color:'#212b36',  marginBottom: "1rem" }}>PIX(Entrada)</Typography>
                </Box>
                <Box sx={{display: "flex", alignItems: "center", justifyContent: "start", }}>
                  { loadingResult ?
                    <Skeleton variant="rectangular" width={200} height={50} />
                    :
                    <Typography sx={{color:'#212b36',  fontWeight: 'bold', flexGrow:1, fontSize: "1.8rem" }} >
                      {transactionMonth?.transaction_pix_in?.total && Masks.money(transactionMonth?.transaction_pix_in?.total.toString())}
                    </Typography>
                  }
                </Box>
              </Item>
            </Grid>
            <Grid item xs={12} md={4} lg={2}>
              <Item >
                <Box sx={{display: "flex", justifyContent: "space-between"}}>
                  <CurrencyExchange sx={{ color:'primary.main',}} />
                  <Box>{transactionMonth?.transaction_pix_out?.quantity} transações</Box>
                </Box>
                <Box>
                  <Typography variant={'overline'} sx={{color:'#212b36',  marginBottom: "1rem" }}>PIX(Saída)</Typography>
                </Box>
                <Box sx={{display: "flex", alignItems: "center", justifyContent: "start", }}>
                  { loadingResult ?
                    <Skeleton variant="rectangular" width={200} height={50} />
                    :
                    <Typography sx={{color:'#212b36',  fontWeight: 'bold', flexGrow:1, fontSize: "1.8rem" }} >
                      {transactionMonth?.transaction_pix_out?.total && Masks.money(transactionMonth?.transaction_pix_out?.total.toString())}
                    </Typography>
                  }
                </Box>
              </Item>
            </Grid>
            <Grid item xs={12} md={4} lg={2}>
              <Item >
                <Box sx={{display: "flex", justifyContent: "space-between"}}>
                  <CurrencyExchange sx={{ color:'primary.main',}} />
                  <Box>{transactionMonth?.transaction_ted_in?.quantity} transações</Box>
                </Box>
                <Box>
                  <Typography variant={'overline'} sx={{color:'#212b36',  marginBottom: "1rem" }}>TED(Entrada)</Typography>
                </Box>
                <Box sx={{display: "flex", alignItems: "center", justifyContent: "start", }}>
                  { loadingResult ?
                    <Skeleton variant="rectangular" width={200} height={50} />
                    :
                    <Typography sx={{color:'#212b36',  fontWeight: 'bold', flexGrow:1, fontSize: "1.8rem" }} >
                      {transactionMonth?.transaction_ted_in?.total && Masks.money(transactionMonth?.transaction_ted_in?.total.toString())}
                    </Typography>
                  }
                </Box>
              </Item>
            </Grid>
            <Grid item xs={12} md={4} lg={2}>
              <Item >
                <Box sx={{display: "flex", justifyContent: "space-between"}}>
                  <CurrencyExchange sx={{ color:'primary.main',}} />
                  <Box>{transactionMonth?.transaction_ted_out?.quantity} transações</Box>
                </Box>
                <Box>
                  <Typography variant={'overline'} sx={{color:'#212b36',  marginBottom: "1rem" }}>TED(Saída)</Typography>
                </Box>
                <Box sx={{display: "flex", alignItems: "center", justifyContent: "start", }}>
                  { loadingResult ?
                    <Skeleton variant="rectangular" width={200} height={50} />
                    :
                    <Typography sx={{color:'#212b36',  fontWeight: 'bold', flexGrow:1, fontSize: "1.8rem" }} >
                      {transactionMonth?.transaction_ted_out?.total && Masks.money(transactionMonth?.transaction_ted_out?.total.toString())}
                    </Typography>
                  }
                </Box>
              </Item>
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={12} >
          <Divider sx={{fontWeight: 'bold', fontSize: "1.5rem", marginY: "2rem"}} />
        </Grid>






      </Grid>


    </>)
}

export default AdminDashboard